export const POST_LOGIN = "/auth/login";
export default {};
